import { EventBus } from "../../event-bus";
import { listService } from "../../services/ListService";
import { ownerService } from "../../services/OwnerService";

import Multiselect from "vue-multiselect";
import { Switch as cSwitch } from "@coreui/vue";
import {
    required,
    requiredUnless,
    minLength,
    maxLength,
    email,
    numeric
} from "vuelidate/lib/validators";
import { VueAutosuggest } from "vue-autosuggest";
import EditAddress from "./../Common/editAddress.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
    name: "EditCompany",

    components: {
        Multiselect,
        cSwitch,
        VueAutosuggest,
        EditAddress
    },

    props: {},

    data() {
        return {
            loading: true,
            //
            company: {},
            //
            leasingCompany: null,
            leasingCompanies: [], // Filled on created()
            //
            fieldOfActivity: null,
            fieldsOfActivity: [], // Filled on created()

            //CNP search
            ownerSuggestions: [],
            debounceMilliseconds: 5000,
            timeout: null,
            inputProps: {
                id: "autosuggest__input",
                placeholder: "cauta dupa cui...",
                class: "form-control",
                name: "uniqueId",
                autocomplete: "off", // google will not propose autofill this textbox
                disabled: false,
                type: "number"
            },
            sectionConfigs: {
                owners: {
                    limit: 6,
                    label: "Companii",
                    onSelected: selected => {
                        console.log("selectHandler" + selected.item.Id);
                        this.company = selected.item;

                        this.getCompanyLastAddress(this.company.Id);

                        // check if this user hads a car
                        EventBus.$emit("owner_selected", selected.item.Id, 1);
                    }
                }
            }
        };
    },

    validations: {
        company: {
            UniqueId: {
                required,
                numeric,
                minLength: minLength(4),
                maxLength: maxLength(10)
            },
            Name: {
                required
            },
            Phone: {
                required
            },
            Email: {
                required,
                email
            }
        },
        leasingCompany: {
            required: requiredUnless("leasingCompanyIsOptional")
        },
        fieldOfActivity: {
            required
        }
    },

    computed: {
        ...mapGetters({
            // general
            appSettings: "general/appSettings",
            userSettings: "general/userSettings",

            orderTypeSettings: "general/orderTypeSettings",
            orderTypeSettingsLoaded: "general/orderTypeSettingsLoaded",
            settingsLoaded: "general/settingsLoaded",

            typeSettings: "general/typeSettings",

            // order
            currentOrderId: "order/currentOrderId",
            order: "order/order",
            orderEditable: "order/orderEditable",
            owner: "order/owner",
            orderCompany: "order/company",
            vehicleOptions: "order/vehicleOptions"
        }),
        //
        isValid() {
            return !this.$v.$anyError;
        },
        companyUniqueIdIsInvalid() {
            return this.$v.company.UniqueId.$anyError;
        },
        leasingCompanyIsInvalid() {
            return this.$v.leasingCompany.$anyError;
        },
        fieldOfActivityIsInvalid() {
            return this.$v.fieldOfActivity.$anyError;
        },
        //
        leasingCompanyIsOptional() {
            return !this.owner.IsLeasing;
        }
    },

    created() {
        EventBus.$on("ownerData_updated", this.loadCompanyData);

        var model = this;
        if (this.vehicleOptions != null) {
            this.loadLeasingCompanies().then(() => {
                model.leasingCompany = this.leasingCompanies.find(
                    item => item.Code == this.owner.LeasingCompany
                );
            });
        }

        this.loadFieldsOfActivity().then(() => {
            this.fieldOfActivity = this.fieldsOfActivity.find(
                item => item.Code == this.company.FieldOfActivity
            );
        });

        this.company = JSON.parse(JSON.stringify(this.orderCompany));

        // Configure the CUI search control
        this.inputProps.disabled = !this.orderEditable;
    },

    methods: {
        ...mapMutations({
            setCompanyToOrder: "order/setCompany",
            setLeasingCompany: "order/setLeasingCompany",
            setOwnerAddress: 'order/setOwnerAddress',
        }),
        //
        validate: function() {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            var addressIsValid = this.$refs.companyAddress.validate();

            return this.isValid && addressIsValid;
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid;
        },

        //#region leasing
        leasingCompany_changed(value) {
            console.log("leasingCompany_changed");
            this.leasingCompany = value;
            this.setLeasingCompany(value);
        },
        leasingSelected(checked) {
            if (!checked) {
                this.leasingCompany = null;
                this.setLeasingCompany(null);
            }
        },
        loadLeasingCompanies() {
            var model = this;

            var promise = listService
                .getLeasingCompanies()
                .then(response => {
                    model.leasingCompanies = response.data;
                })
                .catch(e => {
                    showErrorNotification(e);
                });
            return promise;
        },
        //#endregion

        //#region fieldOfActivity
        fieldOfActivity_changed(value) {
            console.log("fieldOfActivity_changed");
            this.fieldOfActivity = value;
            this.company.FieldOfActivity = value.Code;
        },
        loadFieldsOfActivity() {
            var model = this;

            var fieldsPromise = listService
                .getFieldsOfActivity()
                .then(response => {
                    model.fieldsOfActivity = response.data;
                })
                .catch(e => {
                    showErrorNotification(e);
                });

            return fieldsPromise;
        },
        //#endregion

        //#region CUI
        fetchOwnerSugestions(val) {
            if (val.length > 2) {
                this.loadingPersons = true;
                ownerService.getListByUniqueKey(val, 1).then(response => {
                    this.ownerSuggestions = [];
                    this.ownerSuggestions.push({
                        name: "owners",
                        data: response.data
                    });

                    this.loadingOwners = false;
                });
            }
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.UniqueId;
        },

        loadCompanyData: function () {
            // load person
            this.person = JSON.parse(JSON.stringify(this.orderCompany));
            //load address
            this.$refs.companyAddress.loadAddress();
        },

        getCompanyLastAddress(id) {
            var model = this;
            ownerService.getCompanyLastAddress(id).then(response => {
                var address = response.data;
                address.Id = 0; // reset the address .. will be saved as new address
                model.setOwnerAddress(address);
                model.$refs.companyAddress.loadAddress();
                
            });
        }

        //#endregion
    },

    watch: {
        company: {
            handler: function(val, oldVal) {
                this.setCompanyToOrder(val);
            },
            deep: true
        }
    },

    beforeDestroy() {
        EventBus.$off("ownerData_updated", this.loadCompanyData);
    }
};
